import styled from '@benzinga/themetron';
import { absColDef, AdvancedColDef } from '../helpers/advancedHeader';
import { IRowNode } from 'ag-grid-community';
import React from 'react';
import { CustomCellRendererProps } from 'ag-grid-react';
import { isNilOrEmpty } from '@benzinga/utils';
import { NO_VALUE } from '../../Ticker';
import { formatCellValueOrDefault, getCellValueOrDefault } from '../helpers';

const ChangePercentRenderer: React.FC<CustomCellRendererProps> = props => {
  if (isNilOrEmpty(props.value) || props.value === 0) return <Neutral>{NO_VALUE}</Neutral>;
  const formattedValue = `${props.valueFormatted}%`;
  return props.value > 0 ? <Positive>{formattedValue}</Positive> : <Negative>{formattedValue}</Negative>;
};

const Neutral = styled.div`
  padding: 0 6px;
`;

const Positive = styled(Neutral)`
  color: ${({ theme }) => theme.colors.statistic.positive} !important;
  fill: ${({ theme }) => theme.colors.statistic.positive} !important;
`;

const Negative = styled(Neutral)`
  color: ${({ theme }) => theme.colors.statistic.negative} !important;
  fill: ${({ theme }) => theme.colors.statistic.negative} !important;
`;

export const ChangePercentColDef = (colDef: AdvancedColDef): AdvancedColDef => ({
  cellRenderer: ChangePercentRenderer,
  cellStyle: { textAlign: 'right' },

  // renderer handles
  comparator: (_valueA: number, _valueB: number, nodeA: IRowNode, nodeB: IRowNode) =>
    nodeA.data[nodeA.id ?? ''] - nodeB.data[nodeB.id ?? ''],

  filter: 'agNumberColumnFilter',
  ...colDef,
  ...absColDef({
    ...colDef,
    advancedSort: {
      ...colDef.advancedSort,
      absSort: true,
    } as AdvancedColDef['advancedSort'],
  }),
  valueFormatter: colDef.valueFormatter ?? formatCellValueOrDefault,
  valueGetter: colDef.valueGetter ?? getCellValueOrDefault,
});
